/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { InpectionPhase } from "../inspection.d";
import DisabledAnswersColumn from "./DisabledAnswersColumn";
import AnswerColumn from "./AnswersColumn";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";
import type { IAnswer } from "@/types/types";
import { getAnswers } from "@/lib/services/answers";
import { usePhase } from "@/store/usePhase";
import { getLabelPhase } from "../utils/getLabelPhase";
import { useParams } from "react-router-dom";
import { useUserStore } from "@/store/useUser";

const AnswerGroup = ({
  phase,
  questions,
}: {
  phase: InpectionPhase;
  questions: any[];
}) => {
  const { isSupervisor } = useUserStore();
  const phaseLabel = useMemo(() => {
    return getLabelPhase(phase.phaseId);
  }, []);
  const { currentPhase, setCompleted } = usePhase();
  const queryKey = useMemo(() => `answers-${phase.phaseId}`, [phase]);
  const { inspectionId } = useParams() as { inspectionId: string };
  const translate = useTranslate();
  const {
    data: answers,
    isPending,
    error,
  } = useQuery({
    queryKey: [queryKey, inspectionId],
    queryFn: () =>
      getAnswers({
        inspectionId: Number(inspectionId),
        phaseId: phase.phaseId,
      }),
  });

  useEffect(() => {
    if (currentPhase === phase.phaseId && inspectionId && answers) {
      setCompleted(answers.length);
    }
  }, [answers, currentPhase, phase]);

  if (isPending) {
    return <div>Cargando</div>;
  }
  if (error) {
    <div>error</div>;
  }

  if (!isSupervisor && phase.phaseId === currentPhase) {
    return (
      <AnswerColumn
        questions={questions}
        columnName={translate(phaseLabel)}
        answers={answers as IAnswer[]}
      />
    );
  }

  return (
    <DisabledAnswersColumn
      answers={answers}
      questionsList={questions}
      columnName={translate(phaseLabel)}
      columnPhase={phase.phaseId}
      questions={questions.length}
    />
  );
};

export default AnswerGroup;
